module.exports = __webpack_public_path__ + "img/COMP.5f7da42e.svg";